import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ModalDetalleActuacionTorneo from "@/components/ResultadosTorneos/ModalDetalleActuacionTorneo.vue";
import TablaClasificacionIndividual from "./TablaClasificacionIndividual.vue";
import { Clasificacion } from "@/interfaces/Live";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabClasificacionEquiposIndividual',
  props: {
    tabClasificacion: {},
    activeTab: {},
    clasificacion: {},
    mostrarClasificacion: { type: Boolean }
  },
  setup(__props: any) {



const showModal = ref<boolean>(false);
const clasificacionSelected = ref<Clasificacion>();

function onClickEjercito(jugador: Clasificacion) {
  if (jugador) {
    clasificacionSelected.value = jugador;
    showModal.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window_item = _resolveComponent("v-window-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_v_window_item, {
      value: _ctx.tabClasificacion,
      key: _ctx.tabClasificacion
    }, {
      default: _withCtx(() => [
        (_ctx.mostrarClasificacion !== false)
          ? (_openBlock(), _createBlock(TablaClasificacionIndividual, {
              key: 0,
              clasificacion: _ctx.clasificacion,
              onClickEjercito: onClickEjercito
            }, null, 8, ["clasificacion"]))
          : (_openBlock(), _createBlock(_component_v_alert, {
              key: 1,
              type: "info",
              variant: "tonal",
              class: "ma-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("La clasificación está oculta")
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["value"])),
    _createVNode(ModalDetalleActuacionTorneo, {
      show: showModal.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
      jugador: clasificacionSelected.value!
    }, null, 8, ["show", "jugador"])
  ], 64))
}
}

})